
<template>
  <div class="TripPreview">
    <TripTypeHeader :returnTrip />
    <span v-show="formattedDate" class="TripPreview-date">{{ formattedDate }}</span>
    <span class="TripPreview-cta">{{ t('ui.booking.search.selectionCta') }}</span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@cvo/i18n/composables/useI18n';
import { computed } from 'vue';
import { format } from 'date-fns';
import TripTypeHeader from '../TripTypeHeader/TripTypeHeader.vue';

interface TripPreviewProps {
  date: Date;
  returnTrip?: boolean;
}

const props = defineProps<TripPreviewProps>();

const { t } = useI18n();
const formattedDate = computed(() => {
  if (!props.date) return '';
  return format(props.date, t('ui.date.formats.longDate'));
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .TripPreview {
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-2;

    @include text.text('sm');
    font-weight: vars.$typography-weight-strong;
  }
}
</style>